import AuthService from './auth.service';
import RoleService from './role.service';
import UserService from './user.service';
import NewsfeedService from './newsfeed.service';
import NewscategoryService from './newscategory.service';
import ManufacturerService from './manufacturer.service';
import ProductparameterService from './productparameter.service';
import MediaService from './media.service';
import ProductService from './product.service';
import ClinicService from './clinic.service';
import JournalClubService from './journalclub.service';
import LPProfileService from './lpprofile.service';
import LibraryService from './library.service';
import ContactUsService from './contactus.service';
import CommunityService from './community.service';
import faqService from './faq.service';
import guideCardService from './guidecard.service';
import testimonialsService from './testimonials.service';
import usefullinkService from './usefullink.service';
import eventService from './event.service';
import NotificationService from './notification.service';

export {
  AuthService,
  RoleService,
  UserService,
  NewsfeedService,
  NewscategoryService,
  MediaService,
  ManufacturerService,
  ProductparameterService,
  ProductService,
  ClinicService,
  JournalClubService,
  LPProfileService,
  LibraryService,
  ContactUsService,
  CommunityService,
  faqService,
  guideCardService,
  testimonialsService,
  usefullinkService,
  eventService,
  NotificationService,
}